



































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DialogProgress extends Vue {

    @Prop(Boolean) show!: boolean
    @Prop(String) title!: string
    @Prop(String) text!: string
    @Prop(Number) total!: number
    @Prop(Number) current!: number
    @Prop(Number) progress!: number

    buffer: number = 0
    value: number = 0

    get percentage() {
        this.value = Math.round((this.current / this.total) * 100)
        this.buffer = (((100 / this.total) * (this.progress / 100)) * this.current)
        return `${ this.progress }%`
    }
}
